"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShoppingListMenu = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var react_2 = require("@emotion/react");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_modal_1 = require("@ryerson/frontend.modal");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var ShoppingLists_1 = __importDefault(require("../ShoppingLists/ShoppingLists"));

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var ShoppingListMenu = function ShoppingListMenu(_ref) {
  var mobileBreakPoint = _ref.mobileBreakPoint,
      isShoppingListExpanded = _ref.isShoppingListExpanded,
      setIsShoppingListExpanded = _ref.setIsShoppingListExpanded,
      isSticky = _ref.isSticky,
      storeDirectory = _ref.storeDirectory;

  var _ref2 = (0, frontend_application_1.useApplication)(),
      language = _ref2.localization.language;

  var _ref3 = (0, frontend_theme_1.useTheme)(),
      theme = _ref3.theme;

  var _theme$colors$primary = theme.colors.primary,
      lightGray = _theme$colors$primary.lightGray,
      lighterGray = _theme$colors$primary.lighterGray;

  var getTriggerSection = function getTriggerSection() {
    var background = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "primary";
    var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Shopping List";
    var expanded = arguments.length > 2 ? arguments[2] : undefined;
    var type = arguments.length > 3 ? arguments[3] : undefined;
    return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      className: "popover-menu-root",
      alignItems: "center",
      style: (0, react_2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tpadding: 10px 10px;\n\t\t\t\t"]))),
      children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        alignItems: "center",
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          className: "login-button-text",
          breakPoint: mobileBreakPoint,
          size: "sm",
          weight: "bold",
          type: "tertiary",
          children: trigger
        }), (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          css: {
            marginLeft: 7
          },
          icon: "chevron-down",
          size: "xs",
          color: lightGray
        })]
      })
    });
  };

  return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {
    children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      className: "shopping-list-container",
      children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        className: "shopping-list-button",
        alignItems: "center",
        dataTestId: "header-shopping-list-button",
        children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          style: (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tborder-color: ", ";\n\t\t\t\t\t\t"])), lighterGray),
          children: (0, jsx_runtime_1.jsx)(frontend_modal_1.Popover, {
            trigger: getTriggerSection("tertiary", frontend_common_1.withTranslation["shoppingLists"][language], isShoppingListExpanded, "caret"),
            onOpen: function onOpen() {
              return setIsShoppingListExpanded(true);
            },
            onClose: function onClose() {
              return setIsShoppingListExpanded(false);
            },
            popoverType: "caret",
            alignment: "bottom",
            offset: [0, 4],
            dataTestId: "header-shopping-list-popover",
            children: (0, jsx_runtime_1.jsx)(ShoppingLists_1.default, {
              storeDirectory: storeDirectory,
              isSticky: isSticky,
              setIsShoppingListExpanded: setIsShoppingListExpanded,
              isShoppingListExpanded: isShoppingListExpanded
            })
          })
        })
      })
    })
  });
};

exports.ShoppingListMenu = ShoppingListMenu;